import Vue from 'vue'
import 'xe-utils'
import VXETable from 'vxe-table'
import './vxe-table.scss';
import VXETablePluginVirtualTree from 'vxe-table-plugin-virtual-tree'
import 'vxe-table-plugin-virtual-tree/dist/style.css'
Vue.use(VXETable, {
  size: 'small'
});
VXETable.use(VXETablePluginVirtualTree)
